export class CookieConstantKey {

  public static FILA_CONTRIBUICAO = 'filaContribuicao';

}
